import React, { PropsWithChildren } from 'react';
import HomeIcon from '@material-ui/icons/Home';
import ViewListIcon from '@material-ui/icons/ViewList';
import LibraryBooks from '@material-ui/icons/LibraryBooks';
import {
  Settings as SidebarSettings,
  UserSettingsSignInAvatar,
} from '@backstage/plugin-user-settings';
import { SidebarSearchModal } from '@backstage/plugin-search';
import {
  Sidebar,
  SidebarGroup,
  SidebarItem,
  SidebarPage,
} from '@backstage/core-components';
import MenuIcon from '@material-ui/icons/Menu';
import SearchIcon from '@material-ui/icons/Search';

const SIDEBAR_PIN_STATE = 'sidebarPinState';
window.localStorage.setItem(SIDEBAR_PIN_STATE, JSON.stringify(false));

export const Root = ({ children }: PropsWithChildren<{}>) => (
  <SidebarPage>
    <Sidebar disableExpandOnHover>
      <SidebarGroup label="Search" icon={<SearchIcon />} to="/search">
        <SidebarSearchModal />
      </SidebarGroup>
      <SidebarGroup label="Menu" icon={<MenuIcon />}>
        {/* Global nav, not org-specific */}
        <SidebarItem icon={HomeIcon} to="home" text="Home" />
        <SidebarItem icon={ViewListIcon} to="catalog" text="Catalog" />
        <SidebarItem icon={LibraryBooks} to="docs" text="Docs" />
        {/* End global nav */}
      </SidebarGroup>
      <SidebarGroup
        label="Settings"
        icon={<UserSettingsSignInAvatar />}
        to="/settings"
      >
        <SidebarSettings />
      </SidebarGroup>
    </Sidebar>
    {children}
  </SidebarPage>
);
